module.exports = __webpack_public_path__ + "static/media/manual.3ea7bc08.svg";